import React, { useState, useEffect } from "react";

import "./styles.scss";
import { Resource } from 'app/api/types';

interface IProps {
  onSubmit: (data: Resource, file: undefined, preview?: File) => void;
  onSuccessChange: (active: boolean) => void;
  isSubmit: boolean;
  resource: Resource;
}

const EditResource: React.FC<IProps> = ({
                                          resource,
                                          onSubmit,
                                          onSuccessChange,
                                          isSubmit
                                        }) => {
  const [title, setTitle] = useState(resource.name);
  const [description, setDescription] = useState(resource.description);
  const [preview, setPreview] = useState(undefined as File | undefined);

  const onChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
    e.target.name === "preview" && setPreview(e.target.files[0]);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({
      ...resource,
      name: title,
      description: description
    }, undefined, preview);
  };

  const getHeight = () => {
    let height = 50;
    if (title.length > 1) height += 47;
    if (description.length > 1) height += 20;
    if (description.length > 1 && resource.type !== 'Image') {
      height += 30;
    }

    return height;
  };

  useEffect(() => {
    if (
        title.length > 1 &&
        description.length > 1
    )
      onSuccessChange(true);
    else onSuccessChange(false);

    isSubmit &&
    onSubmit({
      ...resource,
      name: title,
      description: description
    }, undefined, preview);
  }, [
      resource,
    title,
    description,
    preview,
    onSuccessChange,
    onSubmit,
    isSubmit
  ]);

  return (
      <div className="add-phrase" style={{ height: `${getHeight()}px` }}>
        <form className="add-phrase__form" onSubmit={handleSubmit}>
          <input
              className="add-phrase__input"
              onChange={onChange}
              value={title}
              name="title"
              placeholder="Название"
              autoComplete="off"
              required
          />
          {title.length > 1 && (
              <input
                  className={`add-phrase__input`}
                  onChange={onChange}
                  value={description}
                  name="description"
                  placeholder="описание"
                  autoComplete="off"
                  required
              />
          )}
          {description.length > 1 && resource.type !== 'Image' && (
              <label style={{ marginTop: '10px' }}>
                <span>Изображение для предпросмотра</span>
                <input
                    className={`add-phrase__input`}
                    type="file"
                    onChange={onChange}
                    accept=".png,.jpg,.jpeg,.gif"
                    name="preview"
                    placeholder="превью"
                />
              </label>
          )}
        </form>
      </div>
  );
};

export default EditResource;
